module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect"
  }, [_c('a', {
    attrs: {
      "id": "pX"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pX"
    }
  }), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "id": "pX"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007List_of_Illustrations"
    }
  }, [_c('i', [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/009Prologue_Did_Someone_Say_x2018Climate_Changex0027"
    }
  }, [_c('i', [_vm._v("Prologue: Did Someone Say ‘Climate Change'?")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/010Introduction_The_x2018Little_Ice_Agex2019_and_the_x2018General_Crisisx2019"
    }
  }, [_c('i', [_vm._v("Introduction: The ‘Little Ice Age’ and the ‘General Crisis’")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/011PART_I_THE_PLACENTA_OF_THE_CRISIS"
    }
  }, [_vm._v("PART I. THE PLACENTA OF THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/0121_The_Little_Ice_Age"
    }
  }, [_vm._v("1 The Little Ice Age")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/0132_The_x2018General_Crisisx2019"
    }
  }, [_vm._v("2 The ‘General Crisis’")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/0143_x2018Hunger_is_the_greatest_enemyx2019_The_Heart_of_the_Crisis"
    }
  }, [_vm._v("3 ‘Hunger is the greatest enemy’: The Heart of the Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('a', {
    attrs: {
      "href": "#/0154_x2018A_third_of_the_world_has_diedx2019_Surviving_in_the_Seventeenth_Century"
    }
  }, [_vm._v("4 ‘A third of the world has died’: Surviving in the Seventeenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/016PART_II_ENDURING_THE_CRISIS",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II. ENDURING THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0175_The_x2018Great_Enterprisex2019_in_China_1618x201384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The ‘Great Enterprise’ in China, 1618–84")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0186_x2018The_great_shakingx2019_Russia_and_the_PolishLithuanian_Commonwealth_1618x201386",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 ‘The great shaking’: Russia and the Polish-Lithuanian Commonwealth, 1618–86")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0197_The_x2018Ottoman_tragedyx2019_1618x201383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The ‘Ottoman tragedy’, 1618–83")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0208_The_x2018lamentations_of_Germanyx2019_and_its_Neighbours_1618x201388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The ‘lamentations of Germany’ and its Neighbours, 1618–88")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/0219_The_Agony_of_the_Iberian_Peninsula_1618x201389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Agony of the Iberian Peninsula, 1618–89")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02210_France_in_Crisis_1618x201388",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 France in Crisis, 1618–88")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02311_The_Stuart_Monarchy_The_Path_to_Civil_War_1603x201342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Stuart Monarchy: The Path to Civil War, 1603–42")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02412_Britain_and_Ireland_from_Civil_War_to_Revolution_1642x201389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Britain and Ireland from Civil War to Revolution, 1642–89")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/025PART_III_SURVIVING_THE_CRISIS",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III. SURVIVING THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02613_The_Mughals_and_their_Neighbours",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 The Mughals and their Neighbours")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02714_Red_Flag_over_Italy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Red Flag over Italy")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02815_The_x2018dark_continentsx2019_The_Americas_Africa_and_Australia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 The ‘dark continents’: The Americas, Africa and Australia")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/02916_Getting_it_Right_Early_Tokugawa_Japan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Getting it Right: Early Tokugawa Japan")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/030PART_IV_CONFRONTING_THE_CRISIS",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV. CONFRONTING THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03117_x2018Those_who_have_no_means_of_supportx2019_The_Parameters_of_Popular_Resistance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 ‘Those who have no means of support’: The Parameters of Popular Resistance")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03218_x2018People_who_hope_only_for_a_changex2019_Aristocrats_Intellectuals_Clerics_and_x2018dirty_people_of_no_namex2019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 ‘People who hope only for a change’: Aristocrats, Intellectuals, Clerics and ‘dirty people of no name’")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03319_x2018People_of_heterodox_beliefs_x2026_who_will_join_up_with_anyone_who_calls_themx2019_Disseminating_Revolution",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 ‘People of heterodox beliefs … who will join up with anyone who calls them’: Disseminating Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/034PART_V_BEYOND_THE_CRISIS",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART V. BEYOND THE CRISIS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03520_Escaping_the_Crisis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Escaping the Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03621_From_Warfare_State_to_Welfare_State",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 From Warfare State to Welfare State")])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/03722_The_Great_Divergence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 The Great Divergence")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/038Conclusion_The_Crisis_Anatomized",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Conclusion: The Crisis Anatomized")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/039Epilogue_x2018Itx0027s_the_climate_stupidx2019",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue: ‘It's the climate, stupid’")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/040Chronology",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chronology")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/041Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/042Note_on_Conventions",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Note on Conventions")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/043Note_on_Sources_and_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Note on Sources and Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/044Abbreviations_Used_in_the_Bibliography_and_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Abbreviations Used in the Bibliography and Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/046Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents-1"
  }, [_c('span', {
    attrs: {
      "href": "#/047Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52fa256e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006Contents.vue
// module id = 69
// module chunks = 0